export const WHATS_INCLUDED_TABLE_DATA = [
  {
    content: [
      "On-site Housing",
      "A daytrip excursion with the option to add on additional overnight excursions",
      "Access to weekly on-site cultural activities and networking events",
      "24/7 on-site staff to support students working and living abroad",
      "Airport arrival pick up",
      "Medical and Life Insurance",
    ],
    title: "In-Person or Hybrid Internships",
    filled: true,
    type: "list-item",
  },
  {
    content: [
      "Career Coaching for resume and statement of purpose",
      "Access to the API Career Hub for a year which includes benefits like mock interviewing and personal branding exercise",
      "Alumni Network and access to our alumni program",
    ],
    title: "All API Internships",
    filled: false,
    type: "list-item",
  },
];
